<template>
    <div>
        <convenios
            :ConveniosServicos="obterDataServicos()"
            rotaDetalhar="Gescon_Convenios_Financeiro_Detalhar"
            rotaListagem="Gescon_Convenios_Financeiro"
            :temAcessoDetalhar="$temAcessoView('GESCON-FINAN-CONV-02')"
        ></convenios>
        <router-view></router-view>
    </div>
</template>

<script>
import ConveniosServicos from './ConvenioServicos'
import Convenios from '../componentes/ConvenioLista'

export default {
    components: {
        Convenios
    },

    methods: {
        obterDataServicos() {
            return ConveniosServicos
        }
    },
}
</script>

